import { Button, HStack } from '@chakra-ui/react'
import { LuCheck, LuPencil, LuX } from 'react-icons/lu'

interface Props {
  isApproving?: boolean
  disabled?: boolean
  onCorrect: () => void
  onReject: () => void
  onApprove: () => void
}

/**
 * Floating, centered action bar for reviewing an open order.
 * Only rendered by the parent when the active order is actionable (SUBMITTED, Offen tab).
 */
export function OrderReviewActionBar({
  isApproving = false,
  disabled = false,
  onCorrect,
  onReject,
  onApprove,
}: Props) {
  return (
    <HStack
      position="fixed"
      bottom="6"
      left="50%"
      transform="translateX(-50%)"
      zIndex="docked"
      gap={3}
      px={4}
      py={3}
      bg="bg.panel"
      borderWidth="1px"
      borderColor="border"
      borderRadius="2xl"
      boxShadow="lg"
    >
      <Button variant="subtle" onClick={onCorrect} disabled={disabled || isApproving}>
        <LuPencil /> Korrektur vornehmen
      </Button>

      <Button
        colorPalette="red"
        variant="subtle"
        onClick={onReject}
        disabled={disabled || isApproving}
      >
        <LuX /> Ablehnen
      </Button>

      <Button colorPalette="green" onClick={onApprove} loading={isApproving} disabled={disabled}>
        <LuCheck /> Freigeben
      </Button>
    </HStack>
  )
}
